import apiClient from './api';

const messService = {
  // Admin Mess Management
  getMessesAdmin: async () => {
    return apiClient.get('/mess/admin/messes');
  },

  createMess: async (data) => {
    return apiClient.post('/mess/admin/messes', data);
  },

  updateMess: async (id, data) => {
    return apiClient.put(`/mess/admin/messes/${id}`, data);
  },

  deleteMess: async (id) => {
    return apiClient.delete(`/mess/admin/messes/${id}`);
  },

  // Public Mess Endpoints
  getMesses: async () => {
    return apiClient.get('/mess/messes');
  },

  // Admin Membership Management
  getMembershipsAdmin: async () => {
    return apiClient.get('/mess/admin/memberships');
  },

  confirmMembership: async (membershipId) => {
    return apiClient.post(`/mess/admin/membership/${membershipId}/confirm`);
  },

  // Public Memberships
  getMemberships: async (params) => {
    return apiClient.get('/mess/memberships', { params });
  },

  getMembership: async (id) => {
    return apiClient.get(`/mess/memberships/${id}`);
  },

  createMembership: async (data) => {
    return apiClient.post('/mess/memberships', data);
  },

  updateMembership: async (id, data) => {
    return apiClient.put(`/mess/memberships/${id}`, data);
  },

  // Admin Menu Management
  getMenuItemsAdmin: async () => {
    return apiClient.get('/mess/admin/menu');
  },

  // Public Menu
  getMenuItems: async () => {
    return apiClient.get('/mess/menu');
  },

  // Admin Leave Management
  getLeavesAdmin: async () => {
    return apiClient.get('/mess/admin/leaves');
  },

  updateLeaveAdmin: async (id, data) => {
    return apiClient.put(`/mess/admin/leaves/${id}`, data);
  },

  // Public Leaves
  getLeaves: async (params) => {
    return apiClient.get('/mess/leaves', { params });
  },

  createLeave: async (data) => {
    return apiClient.post('/mess/leaves', data);
  },

  updateLeave: async (id, data) => {
    return apiClient.put(`/mess/leaves/${id}`, data);
  },

  approveLeave: async (leaveId) => {
    return apiClient.put(`/mess/leaves/${leaveId}/approve`);
  },

  rejectLeave: async (leaveId) => {
    return apiClient.put(`/mess/leaves/${leaveId}/reject`);
  },

  // Booking Requests
  getBookingRequestsAdmin: async () => {
    return apiClient.get('/mess/admin/booking-requests');
  },

  updateBookingStatus: async (id, data) => {
    return apiClient.put(`/mess/booking-requests/${id}/status`, data);
  },

  createBookingRequest: async (data) => {
    return apiClient.post('/mess/booking-requests', data);
  },

  getMyBookingRequests: async () => {
    return apiClient.get('/mess/booking-requests');
  },

  cancelBookingRequest: async (id) => {
    return apiClient.put(`/mess/booking-requests/${id}/cancel`);
  },
};

export default messService;
